<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main people-results" rel="main" data-page-section="people" style="">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a>Home</a>
							</li>
							<li class="nav-link">
								<span>People</span>
							</li>
						</ul>

					</div>
				</div>
			</div>
			<div class="headline-results-module">
				<div class="headline-people-search-box">
					<div class="background-image desktop-image desktop-image2">
					</div>
					<div class="content">
						<div class="headline page-title-large">People</div>
						<div class="summary">
							Across more than 70 offices, our global team has strong expertise in a wide range of
							disciplines Search for any of our 6,500+ lawyers by name, expertise, office, or keyword.
						</div>
						<div style="visibility: visible;">
							<form class="no-mobile-view search-input-people" method="get">
								<button aria-label="Keyword Search" class="button-submit" type="submit">
									<div class="bm bm-search"></div>
								</button>
								<div class="input-container">
									<label for="mobilepeoplekeywordsearch" class="accessible-label">Search by
										Keyword</label>
									<input class="input" name="mobilepeoplekeywordsearch" type="text" autocomplete="off"
										placeholder="Search by Keyword">
								</div>
								<div class="search-people-results-dropdown">
									<ul></ul>
								</div>
							</form>
							<div class="letter-filter">
								<ul>
									<li v-for="(item,index) in EnglishWord">
										<a>{{item}}</a>
									</li>
								</ul>
							</div>
							<div class="drop-down-menu-filters-people-landing">
								<div class="left filter-container">
									<div class="filter show-filter-list" data-dropdownid="expertise2">
										<span class="filter-label expertise2">
											<a onclick="javascript:void(0)" target="_blank">Expertise</a>
										</span>
									</div>
								</div>
								<div class="right filter-container">
									<div class="filter show-filter-list" data-dropdownid="locations2">
										<span class="filter-label">
											<a onclick="javascript:void(0)" target="_blank">Locations</a>
										</span>
									</div>
								</div>
							</div>
						</div>
						<!-- /ko -->
					</div>
				</div>
			</div>
		</div>
		<footer class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="bm bm-linkedin" aria-label="Baker McKenzie LinkedIn "></a></li>
					<li class="social-link"><a class="bm bm-twitter" aria-label="Baker McKenzie Twitter"></a></li>
					<li class="social-link"><a class="bm bm-facebook" aria-label="Baker McKenzie Facebook "></a></li>
					<li class="social-link"><a class="bm bm-youtube" aria-label="Baker McKenzie YouTube"></a></li>
					<li class="social-link"><a class="bm bm-we-chat" aria-label="Baker McKenzie WeChat"></a></li>
					<li class="social-link"><a class="bm bm-rss" aria-label="Baker McKenzie RSS"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a>Disclaimers</a></li>
					<li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a title="Manage Choices">Cookie Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>

			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</footer>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				EnglishWord: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', "k", 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
					'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
				]
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
			toPage(path) {
				this.$router.replace(path);
			}
		}
	}
</script>

<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	.body-container {
		/* min-width: 1280px; */
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main {
		padding-top: 82px;
	}

	.desktop-image2 {
		background-image: url('../../assets/test/81.webp');
	}

	.search-input-people .button-submit {
		padding: 0 0.75em;
	}
	@media screen and (max-width: 47.9375em){
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main {
			padding-top: 63px;
		}
	}
</style>
